import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { slide as Menu } from 'react-burger-menu'


{/* LOGOS EN BLANCO */ }
import LogoMagueySVG from '../../../../img/logoBlancoSVG2.svg';
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import estilos from './MenuHamburguesaCertificado.module.css'; { {/*Estilos para el componente*/ } }

import {
    faUsers, faUser, faCheckDouble, faCircleInfo, faPerson, faPenToSquare, faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons'
import BotonMenuHamburguesaCertificacion from './BotonMenuHamburguesaCertificacion';

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box, Typography } from "@mui/material";

library.add(faUsers, faUser, faPenToSquare, faCircleInfo, faPerson)


const MenuHamburguesaCertificado = (props) => {

    var styles = {
        bmBurgerButton: {
            position: 'fixed',
            width: '36px',
            height: '30px',
            left: '36px',
            top: '45px'
        },
        bmBurgerBars: {
            background: '#F1C77E'
        },
        bmBurgerBarsHover: {
            background: '#a90000'
        },
        bmCrossButton: {
            height: '24px',
            width: '24px'
        },
        bmCross: {
            background: '#F1C77E'
        },
        bmMenuWrap: {
            position: 'fixed',
            height: '100%'
        },
        bmMenu: {
            background: '#072036',
            padding: '2.5em 1.5em 0',
            fontSize: '1.15em'
        },
        bmMorphShape: {
            fill: '#373a47'
        },
        bmItemList: {
            color: '#F1C77E',
            padding: '0.8em'
        },
        bmItem: {
            display: 'inline-block'
        },
        bmOverlay: {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    }

    const currentUser = useSelector(store => store.Usuario.data)
    let idUsuario = 0
    if (currentUser) {
        idUsuario = currentUser.user[0].id
    }
    const dataUser = useSelector(store => store.Usuario.user)
    const [value, setValue] = React.useState("1");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Fragment>
            <div className={`${estilos.header}`}>
                <Fragment>
                    <header className='row text-center'>
                        <div className='col-1'></div>
                        <div className='col-10' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                            <div className='row'>
                                {dataUser?.[0]?.idrol == 1 &&
                                    <div className='col-12 mt-2' >
                                        <span className='textoEscondido text-center' style={{ color: '#F1C77E' }}>
                                            <strong>ORGANISMO DE CERTIFICACIÓN</strong><br />Administrador Nacional
                                        </span>
                                        <Box display="flex" justifyContent="center" width="100%" sx={{ marginTop: '10px' }}>
                                            <Tabs value={value} onChange={handleChange}
                                                aria-label="icon tabs example"
                                                variant='scrollable'
                                                scrollButtons={true}
                                                allowScrollButtonsMobile={true}
                                                TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                                sx={{
                                                    minHeight: "35px", height: "35px",
                                                    "& button": { color: '#F1C77E', paddingTop: 0, fontFamily: 'Montserrat' },
                                                    "& button:hover": { color: '#F1C77E', transform: 'scale(1.1)' },
                                                    "& button.Mui-selected": { backgroundColor: '#FFFFFF', color: '#072036', fontWeight: 'bold', borderTopLeftRadius: 5, borderTopRightRadius: 5 },
                                                }}>
                                                <Tab label="Recibidas" value="1" onClick={() => { props.history.push('/SolicitudesOrganismoComponent') }} />
                                                <Tab label="Atendidas AC" value="2" onClick={() => { props.history.push('/TabsSolicitudesAtendidasACComponent') }}/>
                                                <Tab label="UI" value="3" onClick={() => { props.history.push('/TabsSolicitudesEstatusUIComponent') }} />
                                                <Tab label="En revisión por OC " value="4" onClick={() => { props.history.push('/SolicitudesRevisionOCUIComponent') }} />
                                                <Tab label="Seguimiento" value="5" onClick={() => { props.history.push('/SeguimientoComponent') }}/>
                                            </Tabs>
                                        </Box>
                                    </div>
                                }
                                {dataUser?.[0]?.idrol == 7 &&
                                    <div className='col-12 mt-2'>
                                        <span className='textoEscondido text-center' style={{ color: '#F1C77E' }}>
                                            <strong>ORGANISMO DE CERTIFICACIÓN</strong><br />Auxiliar Nacional
                                        </span>
                                        <Box display="flex" justifyContent="center" width="100%" sx={{ marginTop: '10px' }}>
                                            <Tabs value={value} onChange={handleChange}
                                                aria-label="icon tabs example"
                                                variant='scrollable'
                                                scrollButtons={true}
                                                allowScrollButtonsMobile={true}
                                                TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                                sx={{
                                                    minHeight: "35px", height: "35px",
                                                    "& button": { color: '#F1C77E', paddingTop: 0, fontFamily: 'Montserrat' },
                                                    "& button:hover": { color: '#F1C77E', transform: 'scale(1.1)' },
                                                    "& button.Mui-selected": { backgroundColor: '#FFFFFF', color: '#072036', fontWeight: 'bold', borderTopLeftRadius: 5, borderTopRightRadius: 5 },
                                                }}>
                                                <Tab label="Recibidas" value="1" onClick={() => { props.history.push('/SolicitudesOrganismoComponent') }} />
                                                <Tab label="Atendidas AC" value="2" onClick={() => { props.history.push('/TabsSolicitudesAtendidasACComponent') }}/>
                                                <Tab label="UI" value="3" onClick={() => { props.history.push('/TabsSolicitudesEstatusUIComponent') }} />
                                                <Tab label="En revisión por OC " value="4" onClick={() => { props.history.push('/SolicitudesRevisionOCUIComponent') }} />
                                                <Tab label="Seguimiento" value="5" onClick={() => { props.history.push('/SeguimientoComponent') }}/>
                                            </Tabs>
                                        </Box>
                                    </div>
                                }
                            </div>

                        </div>
                        <div className='col-1' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Tooltip title="Salir de la aplicación" arrow>
                                <button style={{ border: 'none', padding: '4px', backgroundColor: 'transparent', color: '#F1C77E', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} onClick={props.cerrarSesionModal} className="text-wrap text-center botonZoom"> <FontAwesomeIcon style={{ transform: 'scale(1.5)' }} icon={faRightFromBracket} /><br />Salir</button>
                            </Tooltip>

                        </div>

                    </header>
                </Fragment>
            </div>
            <Menu styles={styles}>
                <List className={`${estilos.lista}`}>
                    {dataUser?.[0]?.idrol == 1 &&
                        <Fragment>
                            {/*<BotonMenuHamburguesaCertificacion titulo="Solicitudes OC" objeto={[]} ruta="/SolicitudesOrganismoComponent" icon={faPenToSquare}></BotonMenuHamburguesaCertificacion>*/}
                            <BotonMenuHamburguesaCertificacion titulo="Panel Usuarios" objeto={[]} ruta="/UsuariosOCNacionalComponent" icon={faUsers}></BotonMenuHamburguesaCertificacion>
                            <BotonMenuHamburguesaCertificacion titulo="Modulo de Consulta" objeto={[]} ruta="/ModuloConsultaOCComponent" icon={faCircleInfo}></BotonMenuHamburguesaCertificacion>
                        </Fragment>
                    }
                </List>
                {dataUser?.[0]?.idrol == 7 &&
                    <Fragment>
                        <BotonMenuHamburguesaCertificacion titulo="Solicitudes OC" objeto={[]} ruta="/SolicitudesOrganismoComponent" icon={faPenToSquare}></BotonMenuHamburguesaCertificacion>
                        <BotonMenuHamburguesaCertificacion titulo="Modulo de Consulta" objeto={[]} ruta="/ModuloConsultaOCComponent" icon={faCircleInfo}></BotonMenuHamburguesaCertificacion>

                    </Fragment>
                }
            </Menu>
            <br /><br /><br /><br />
            {props.componenteCerrarSesionModal}
        </Fragment >
    );
};
export default withRouter(MenuHamburguesaCertificado)
